import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';

import {
  fadeTimingMs,
  landingPageClasses,
  getDarkThemeClass,
} from '../utility/constants';

const headline = 'More for the Grow.';
const description =
  'SmartGrow is a SaaS platform powered by big data designed to help businesses maximize margins and profits through their cannabis cultivation operations.';

const body = `
SmartGrow is a software platform that helps licensed cannabis operators optimize cultivation through data insights, automation, and environmental monitoring. Our system integrates directly with METRC and TrolMaster to provide analytics, compliance tracking, and real-time environmental control.

By using SmartGrow, you authorize the platform to securely access and process data from your METRC and TrolMaster accounts using the API keys or credentials you provide. Your METRC key will be used to read, create, and update records within your licensed environment as needed for compliance and operational management.

You retain full ownership of your data. SmartGrow will never sell, share, or disclose identifiable customer information without your consent, except when required by law or regulatory authorities. Users are responsible for providing accurate data and safeguarding their login and integration credentials.

SmartGrow follows industry-standard security and encryption practices to protect your data but is not liable for issues arising from user-provided data, incorrect credentials, or third-party system errors.

For detailed documentation on integrations and data handling, please visit docs.smartgrow.farm.  
For assistance or questions, contact support@smartgrow.farm or visit www.smartgrow.farm.
`;

export default function TermsAndCondition() {
  const theme = useTheme();
  const navigate = useNavigate();

  const currDarkThemeClass = useMemo(() => getDarkThemeClass(theme), [theme?.palette?.themeMode]);

  const lPBoxProps = { className: `${landingPageClasses?.box} ${currDarkThemeClass}` };
  const lPNavBoxProps = { className: `${landingPageClasses?.navBox} ${currDarkThemeClass}` };
  const lPContentBoxProps = { className: `${landingPageClasses?.contentBox} ${currDarkThemeClass}` };
  const lPNavTitleTypoProps = { noWrap: true, className: `${landingPageClasses?.navTitleTypo} ${currDarkThemeClass}` };
  const lPHeadlineTypoProps = { className: `${landingPageClasses?.headlineTypo} ${currDarkThemeClass}` };
  const lPDescTypoProps = { className: `${landingPageClasses?.descTypo} ${currDarkThemeClass}` };

  const lPNavAccessBtnProps = ({ login, logout }) => ({
    className: `${landingPageClasses?.navAccessBtn} ${currDarkThemeClass}`,
    onClick: () => (navigate("/")),
    variant: 'contained',
  });

  const lContactBtnProps = {
    className: `${landingPageClasses?.accessBtn} ${currDarkThemeClass}`,
    onClick: () => navigate(-1),
    variant: 'contained',
  };

const ldocsBtnProps = {
  className: `${landingPageClasses?.accessBtn} ${currDarkThemeClass}`,
  onClick: () => window.open("https://docs.smartgrow.farm", "_blank"),
  variant: 'contained',
};

  return (
    <Box {...lPBoxProps}>
      <Box {...lPNavBoxProps}>
        <Typography {...lPNavTitleTypoProps}>SMARTGROW</Typography>
          <>
            <Button {...lPNavAccessBtnProps({})}>Home</Button>
          </>
      </Box>

      <Fade in timeout={fadeTimingMs}>
        <Box {...lPContentBoxProps} sx={{ textAlign: 'left', maxWidth: 900, mx: 'auto', mt: 4 }}>
          <Typography {...lPHeadlineTypoProps}>{headline}</Typography>
          <Typography {...lPDescTypoProps}>{description}</Typography>

          <Fade in timeout={fadeTimingMs}>
            <Box sx={{ mt: 3 }}>
              {body.split('\n\n').map((para, idx) => (
                <Typography key={idx} sx={{ color: 'white', mb: 2 }}>
                  {para}
                </Typography>
              ))}
            </Box>
          </Fade>

          <Box display="flex" gap={2} mt={4}>
            <Button {...lContactBtnProps}>Back</Button>
            <Button target="_blank" {...ldocsBtnProps}>
              Smartgrow User Manual
            </Button>
          </Box>
        </Box>
      </Fade>
    </Box>
  );
}
